import { Component, OnInit } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/widget.svg',
})
export class WidgetComponent {}
